const PermissionPrefix = {
    SYSADMIN: 'farmindo.',
    SYSUSER_ADMIN: 'admin_seller.',
    SYSUSER_CS: 'support.',
    SYSUSER_BUYER: 'buyer.',
    SYSUSER_SELLER: 'seller.'
  }
  
  export default PermissionPrefix;